import { QUERY_KEYS } from "@/common/query-keys";
import { fetchConsumableById } from "@/lib/snipeit/consumables";
import { useQuery } from "@tanstack/react-query";
import { useSearch } from "wouter";

/**
 * Reads the `id` search-parameter, fetches the single consumable by ID,
 * and returns it together with a loading flag.
 */
export function useConsumableFromSearchParam() {
  const search = useSearch();
  const id = new URLSearchParams(search).get("id");

  const { data: selected = null, isLoading } = useQuery({
    queryKey: [QUERY_KEYS.consumableFromParam, id],
    queryFn: () => fetchConsumableById(Number(id)),
    enabled: !!id,
    staleTime: 30_000,
  });

  return { selected, loading: !!id && isLoading };
}
